export default __webpack_public_path__ + "static/political-sociology-059e1f97becb9ae1c14c7029518109a3.png";